import React from 'react';
import { useTranslation } from 'react-i18next';

import { CButton } from '@app/components/Common';
import { Text, View } from '@/styles/reactnative';
import { useToken } from '@app/hooks';
import { COLORS } from '@app/constants';
import { TRANSFER } from '@app/constants/APIKEYS';
import API from '@utils/api';
import { toast } from 'react-toastify';
import { useBalance } from '../../../hooks/user/mybalance';
import { USER_LOG_TYPE, useUserLogger } from '@/app/hooks/userLogger';
import { message } from 'antd';

const TransferFooter = ({
  transferFrom,
  transferTo,
  amount,
  coinType,
  balance,
}) => {
  const { t } = useTranslation();
  const { data: token } = useToken();
  const { mutate: mutateFrom } = useBalance(coinType, transferFrom);
  const { mutate: mutateTo } = useBalance(coinType, transferTo);
  const { mutateUserLog } = useUserLogger();

  const [isTrasferring, setIsTransferring] = React.useState(false);

  const type = 'USDT';

  const logConvert = {
    0: '현물지갑',
    1: '선물지갑',
    9: '전체지갑',
    7: '리워드지갑',
  };

  const onTransfer = () => {
    if (isTrasferring) {
      return message.error(t('transferInProgress'));
    }

    setIsTransferring(true); // 전송 시작
    if (amount > 0) {
      const data = {
        transfer_from: transferFrom,
        transfer_to: transferTo,
        coin_type: type,
        amount: amount,
      };

      const log = `${logConvert[transferFrom]} -> ${logConvert[transferTo]} (${amount}테더)`;
      mutateUserLog({
        log: `[지갑이동 요청]: ${log}`,
        data,
      });
      API.post(TRANSFER, token + '', data)
        .then((res) => {
          if (res.result.result == true) {
            mutateUserLog({
              log: `[지갑이동 성공]: ${log}`,
              data,
            });
            toast(t('transferSuccess') + '');
            mutateFrom();
            mutateTo();
          } else {
            mutateUserLog({
              log: `[지갑이동 실패]: ${log} / ${t(res?.result?.message)}`,
              data,
            });
            toast(t(res?.result?.message) + '');
          }
        })
        .catch((err) => {
          mutateUserLog({
            log: `[실패]: ${log}`,
            data,
          });
          console.error('Transfer error:', err);
        })
        .finally(() => {
          setIsTransferring(false); // 전송 완료
        });
    }
  };
  return (
    <View
      style={{
        width: "100%",
        justifyContent: "flex-start",
        margin: '30px 0' 
      }}
    >
      <CButton
        title={t('confirm')}
        onClick={onTransfer}
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding: 12,
          background: COLORS.primary,
          color: COLORS.white,
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 'bold',
        }}
      />
      {/* {transferFrom === 1 ? (
        <Text size={10} style={{ color: COLORS.lightRed, marginTop: 15 }}>
          {t("transferRedAlert")}
        </Text>
      ) : null} */}

      {/* <CButton
				title={t('toLoan')}
				style={{ color: COLORS.primary, marginTop: 15 }}
				icon={<IconChevronRight size={14} />}
			/> */}
    </View>
  );
};

export default TransferFooter;
